/**
 * This module only contains the display elements of the breaking news bar and
 * should not be used directly. To implement the breaking news bar, use
 * the component epxorted from components/BreakingNewsBar.
 *
 * Separating the display and data fetching parts of the breaking news bar
 * allow us to only load the styles if they're necessary.
 */

import cx from "classnames";
import { useId } from "@reach/auto-id";

import styles from "./BreakingNewsBarDisplay.module.scss";
import { BreakingNews } from "types/api";

const BreakingNewsBarDisplay = ({
  breakingNews,
  analyticsCategory,
}: {
  breakingNews: Omit<BreakingNews, "homepageEnabled">;
  analyticsCategory?: string;
}) => {
  const kickerId = useId();
  return (
    <aside
      className={cx(styles.root, styles[breakingNews.theme.toLowerCase()])}
      aria-labelledby={kickerId}
      data-category={analyticsCategory}
    >
      <div className={styles.container}>
        <p className={styles.content}>
          {breakingNews.kicker && (
            <span id={kickerId} className={styles.kicker}>
              {breakingNews.kicker}
            </span>
          )}
          {breakingNews.url ? (
            <a
              href={breakingNews.url}
              className={styles.link}
              dangerouslySetInnerHTML={{ __html: breakingNews.text }}
              data-action={`click link - breaking bar`}
              data-label={breakingNews.url}
            />
          ) : (
            <span
              className={styles.text}
              dangerouslySetInnerHTML={{ __html: breakingNews.text }}
            />
          )}
        </p>
      </div>
    </aside>
  );
};

export default BreakingNewsBarDisplay;
